import useLazyQuery from 'api/hooks/useLazyQuery';
import permissions from 'api/Apollo/permissions';
import { buildVariables, GET_ANALYTICS_FILES } from './analytics-files-query-builder';
import transformAnalyticsFiles from './transformAnalyticsFiles';

export default function useLazyQueryAnalyticsFiles({ ...options } = {}) {
  const [executeQuery, { data, ...rest }] = useLazyQuery(GET_ANALYTICS_FILES, {
    context: { permission: permissions.readPipeline },
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-and-network',
    ...options,
  });

  const getAnalyticsFiles = queryParams => {
    const variables = buildVariables(queryParams);
    executeQuery({ variables });
  };

  return [
    getAnalyticsFiles,
    {
      ...buildResponse(data),
      ...rest,
    },
  ];
}

function buildResponse(data) {
  if (data) {
    return {
      analyticsFiles: transformAnalyticsFiles(data.analyticsFiles),
      pagination: data.analyticsFilesAggregate.aggregate,
    };
  }

  return {
    analyticsFiles: [],
    pagination: { count: null },
  };
}
